import React, { useEffect, useState } from 'react';
import { Notification } from './Notifications';
import { apiErrorEventName } from '../../utils/api/apiRequest';

export const GlobalApiErrorNotifications = () => {
    const [notification, setNotification] = useState(null);

    useEffect(() => {
        const handleApiError = (event) => {
            const nextMessage = event?.detail?.message;

            if (!nextMessage) {
                return;
            }

            setNotification({
                id: Date.now(),
                message: nextMessage,
                type: 'error',
            });
        };

        window.addEventListener(apiErrorEventName, handleApiError);

        return () => {
            window.removeEventListener(apiErrorEventName, handleApiError);
        };
    }, []);

    if (!notification) {
        return null;
    }

    return <Notification key={notification.id} message={notification.message} type={notification.type} />;
};
